import styled from 'styled-components';

export const IconContainer = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'isActive',
})`
  cursor: pointer;
  width: 36px;
  height: 36px;
  aspect-ratio: 1;
  margin: 0 10px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  svg {
    stroke: ${(props) => props.theme.colors.title};
    fill: ${({ isActive, theme }) =>
      isActive ? theme.colors.link : 'none'} !important;

    &.disactive {
      position: relative;

      &::after {
        content: '';
        width: 141%;
        height: 2px;
        border-radius: 2px;
        position: absolute;
        bottom: 8px;
        left: -4px;
        -ms-transform: rotate(45deg);
        transform: rotate(-45deg);
        background-color: ${(props) => props.theme.colors.textPrimary};
      }
    }
  }

  &:hover {
    svg {
      stroke: ${(props) => props.theme.colors.btnHover};
    }
  }

  .notification-badge {
    width: 6px;
    height: 6px;
    position: absolute;
    background: ${(props) => props.theme.colors.fail};
    top: 9px;
    right: 9px;
    z-index: 1;
    border-radius: 100%;
    outline: 1.7px solid ${(props) => props.theme.colors.fail};
    border: 1.5px solid ${(props) => props.theme.colors.fail};
  }
`;

export const IconSpan = styled.span`
  font-size: 20px;
`;
